module.exports = __webpack_public_path__ + "img/prize-sm-light.3d91510d.png";